import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "flex flex-column justify-content-evenly align-items-center text-white font-medium" }
const _hoisted_2 = { class: "flex gap-5 cursor-pointer" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm" }, "Copyright (c) Medical WEB all rights reserved.", -1)

import RouterConstants from "@/clinic/constants/router.constants";
import RouterUtils from "@/common/utils/router.util";
import { ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'footer',
  setup(__props) {

const items = ref([
  {
    label: "プライバシーポリシー",
    routeName: RouterConstants.PRIVACY_POLICY_ROUTER_NAME,
  },
  {
    label: "運営会社",
    routeName: RouterConstants.COMPANY_PROFILE_ROUTER_NAME,
  },
  {
    label: "利用規約",
    routeName: RouterConstants.TERMS_OF_SERVICE_ROUTER_NAME,
  },
]);
const onClick = (routeName: string) => RouterUtils.goTo(routeName);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, (item) => {
        return (_openBlock(), _createElementBlock("span", {
          key: item.label,
          class: "text-lg no-underline",
          onClick: ($event: any) => (onClick(item.routeName))
        }, _toDisplayString(item.label), 9, _hoisted_3))
      }), 128))
    ]),
    _hoisted_4
  ]))
}
}

})